<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Collapse } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { getStatusIconByRole } from 'src/helpers/xt1_helpers/template_helpers';
	import {
		getVolumeUnitOptions,
		getPresureUnitOptions,
	} from 'src/helpers/xt1_helpers/template_units_helpers';
	//Components
	import NeoValveTemperatureUnits from './NeoValveTemperatureUnits.svelte';
	import NeoValveResetConsumption from './NeoValveResetConsumption.svelte';
	import NeoValveAlarms from './NeoValveAlarms.svelte';
	import NeoValveUnits from './NeoValveUnits.svelte';
	import ValveActionOnPowerRestored from '../Valve/ValveActionOnPowerRestored.svelte';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	const collapseSubMenu: any = [
		{
			component: NeoValveTemperatureUnits,
			title: $format('sub_settings_title_temperature_unit', {
				default: 'Temperature units',
			}),
			props: {
				device,
			},
			expanded: false,
		},
		{
			component: NeoValveUnits,
			title: $format('sub_settings_title_water_pressure_unit', {
				default: 'Water pressure units',
			}),
			props: {
				device,
				options: getPresureUnitOptions(),
				property: 'pressure_unit',
				icon: getStatusIconByRole('water_pressure'),
				sub_title: $format('select_water_pressure_units', {
					default: 'Choose water pressure units:',
				}),
			},
			expanded: false,
		},
		{
			component: NeoValveUnits,
			title: $format('sub_settings_title_water_volume_unit', {
				default: 'Water volume units',
			}),
			props: {
				device,
				options: getVolumeUnitOptions(),
				property: 'volume_unit',
				icon: getStatusIconByRole('water_consumption'),
				sub_title: $format('select_water_volume_units', {
					default: 'Choose water volume units:',
				}),
			},
			expanded: false,
		},
		{
			component: NeoValveAlarms,
			title: $format('sub_settings_title_temperature_alarm', {
				default: 'Water Temperature Alarm',
			}),
			props: {
				device,
				role: 'water_temperature',
				type: 'alarm_temp',
			},
			expanded: false,
		},
		{
			component: NeoValveAlarms,
			title: $format('sub_settings_title_pressure_alarm', {
				default: 'Water Pressure Alarm',
			}),
			props: {
				device,
				role: 'water_pressure',
				type: 'alarm_pressure',
			},
			expanded: false,
		},
		{
			component: NeoValveAlarms,
			title: $format('sub_settings_title_volume_alarm', {
				default: 'Water Volume Alarm',
			}),
			props: {
				device,
				role: 'flow_rate',
				type: 'alarm_flow_rate',
			},
			expanded: false,
		},
		{
			component: ValveActionOnPowerRestored,
			title: $format('sub_settings_title_valve_action_on_power_restored', {
				default: 'Valve action on power restored',
			}),
			props: {
				device,
			},
			expanded: false,
		},
		{
			component: NeoValveResetConsumption,
			title: $format('sub_settings_title_reset_water_consumption', {
				default: 'Reset water consumption',
			}),
			props: {
				device,
			},
			expanded: false,
		},
	];
</script>

{#each collapseSubMenu as { title, component, props, expanded }}
	<Collapse
		id="collapse-4eiqr78"
		title={capFirstChar(title)}
		class="mb-s"
		{expanded}
		on:click={() => {
			if (expanded) {
				expanded = false;
			} else {
				collapseSubMenu.forEach((i) => {
					i.expanded = false;
				});
				expanded = true;
			}
		}}
	>
		<svelte:component this={component} {...props} />
	</Collapse>
{/each}
